import { apiErrorMessage } from './ApiError';
import { axiosApi } from './axios.api';
import { PermissionDataArray, PermissionModel, PermissionQueryParams } from '@app/interfaces/permission';

const url = `/api/permissions`;

export const getPermissionsApi = async (params?: PermissionQueryParams): Promise<PermissionDataArray | undefined> => {
  try {
    const response = await axiosApi.get<PermissionDataArray>(url, { params });
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const createPermissionApi = async (data: PermissionModel) => {
  try {
    const response = await axiosApi.post(url, data);
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const updatePermissionApi = async (permissionId: number, formData: PermissionModel) => {
  try {
    const response = await axiosApi.put(`${url}/${permissionId}`, formData);
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const deletePermissionApi = async (permissionId: number) => {
  try {
    const response = await axiosApi.delete(`${url}/${permissionId}`);
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const exportPermissionApi = async (params?: Record<string, unknown>) => {
  try {
    const response = await axiosApi.get(`${url}/export`, { params, responseType: 'blob' });

    const newUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = newUrl;
    link.setAttribute('download', `permissions.xlsx`);
    document.body.appendChild(link);
    link.click();

  } catch (error: any) {
    apiErrorMessage(error);
  }
};